import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../ui/button';

const BackButton = ({ to, label }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleBack = () => {
    if (to) {
      navigate(to);
    } else {
      navigate(-1);
    }
  };

  return (
    <Button
      variant="ghost"
      onClick={handleBack}
      className="mb-6 text-[#2B2D42] hover:text-[#00B4D8] hover:bg-[#F0F9FF]"
    >
      <ArrowLeft className="mr-2 h-4 w-4" />
      {label || t('common.back')}
    </Button>
  );
};

export default BackButton;
